export default {
  headline: 'User subscriptions',
  subheadline: 'Setup user notification services',
  noUserSelected: 'Please select a user',
};
